import type { ElementType } from 'react';
import { AlertCircle, AlertTriangle, CheckCircle } from '@untitledui/icons';
import { InAppNotificationType, type InAppNotification } from '../../types/ui/inAppNotification';
import { Icon } from './Icon';
import { Text } from './Text';

const typeStyles: Record<
  (typeof InAppNotificationType)[keyof typeof InAppNotificationType],
  { text: string; icon: ElementType; iconColor: string }
> = {
  [InAppNotificationType.SUCCESS]: {
    text: 'var(--text-primary)',
    icon: CheckCircle,
    iconColor: 'var(--color-success)'
  },
  [InAppNotificationType.WARNING]: {
    text: 'var(--text-primary)',
    icon: AlertTriangle,
    iconColor: 'var(--color-warning)'
  },
  [InAppNotificationType.ERROR]: {
    text: 'var(--color-danger)',
    icon: AlertCircle,
    iconColor: 'var(--color-danger)'
  }
};

interface InAppNotificationCardProps {
  notification: InAppNotification & { id: string };
}

export function InAppNotificationCard({ notification }: InAppNotificationCardProps) {
  const styles = typeStyles[notification.type];

  return (
    <div
      onClick={() => {
        if (notification.onClick) {
          notification.onClick(notification);
        }
      }}
      style={{
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        color: styles.text,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        textAlign: 'start',
        cursor: notification.onClick ? 'pointer' : 'default',
        animation: 'slideIn 0.3s ease-out'
      }}
    >
      <div style={{ marginRight: '8px', display: 'flex', alignItems: 'center' }}>
        <Icon icon={styles.icon} color={styles.iconColor} />
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        {notification.title && <Text variant='body1-medium'>{notification.title}</Text>}
        {notification.body && <Text variant='body1'>{notification.body}</Text>}
        {notification.bottomComponent && <div>{notification.bottomComponent}</div>}
      </div>
    </div>
  );
}
